/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPmiReference = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.496 17.313V7.135h3.682c1.195 0 2.105.266 2.73.798.626.532.938 1.302.938 2.31 0 .747-.196 1.367-.588 1.862-.382.495-.938.84-1.666 1.036l2.688 4.172h-1.946l-2.38-3.836-1.722-.35v4.186H5.496zm1.736-5.334h1.302c.644 0 1.153-.056 1.526-.168.373-.112.64-.29.798-.532.159-.252.238-.588.238-1.008 0-.43-.08-.77-.238-1.022-.159-.252-.425-.43-.798-.532-.373-.112-.882-.168-1.526-.168H7.232v3.43zm7.954 5.334v-6.034h-1.288v-.854l1.288-.49v-.602c0-1.764.85-2.646 2.548-2.646.261 0 .5.023.714.07v1.316a1.487 1.487 0 0 0-.21-.014 1.487 1.487 0 0 0-.21-.014c-.41 0-.705.098-.882.294-.168.196-.252.518-.252.966v.644h1.61v1.33h-1.61v6.034h-1.708z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPmiReference as PmiReference };
